import React from "react";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from "@mui/material";

import styles from "./ExclusiveAccordionList.module.scss";

interface AccordionItem {
  title: string;
  content: React.ReactNode;
  isPassed?: boolean;
}

interface ExclusiveAccordionListProps {
  items: AccordionItem[];
  expandedIndex: number | null;
  onChangeExpanded: (index: number | null) => void;
  accordionRefs: React.MutableRefObject<(HTMLDivElement | null)[]>;
}

const ExclusiveAccordionList: React.FC<ExclusiveAccordionListProps> = ({
  items,
  expandedIndex,
  onChangeExpanded,
  accordionRefs,
}) => {
  return (
    <div>
      {items.map((item, index) => (
        <div
          ref={el => {
            accordionRefs.current[index] = el;
          }}
          key={item.title}
        >
          <Accordion
            expanded={expandedIndex === index}
            onChange={() =>
              onChangeExpanded(expandedIndex === index ? null : index)
            }
            className={styles.accordionRoot}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography fontWeight={600}>{item.title}</Typography>
              {item.isPassed && (
                <Typography fontWeight={600} color="primary" marginLeft={2}>
                  Passed
                </Typography>
              )}
            </AccordionSummary>
            <AccordionDetails>{item.content}</AccordionDetails>
          </Accordion>
        </div>
      ))}
    </div>
  );
};

export default ExclusiveAccordionList;
